import { FileMagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/FileMagnifyingGlass";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";

/**
 * A quiet "Source" icon beside a figure: it opens the file the figure was
 * read from. Shown on hover or focus of its row (`group/source` on the row),
 * and always on a touch screen, which has no hover.
 */
export const SourceButton = ({
  label,
  onClick,
  className,
}: {
  /** Names it for assistive technology: "Show where Labor comes from". */
  label: string;
  onClick: () => void;
  className?: string;
}) => (
  <Tooltip>
    <TooltipTrigger
      render={
        <Button
          variant="ghost"
          size="icon-xs"
          aria-label={label}
          onClick={(event) => {
            // A row that opens its record keeps the click to itself.
            event.stopPropagation();
            onClick();
          }}
          className={cn(
            "flex-none text-subtle opacity-0 transition-opacity group-focus-within/source:opacity-100 group-hover/source:opacity-100 focus-visible:opacity-100 data-popup-open:opacity-100 pointer-coarse:opacity-100",
            className,
          )}
        />
      }
    >
      <FileMagnifyingGlassIcon aria-hidden />
    </TooltipTrigger>
    <TooltipContent>Show where this comes from</TooltipContent>
  </Tooltip>
);
